/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var BreadcrumbView = require('common/views/BreadcrumbView');

var Radio = require('backbone.radio');

var SubmitContact = require('../services/SubmitContact');

var tmplCOCContactEditView = require('../templates/COCContactEditView.hbs');
var COCContactFormView = require('./COCContactFormView');
var modelGet = require('common/util/modelGet');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCContactEditView,

  className: 'coc-contact-edit-view container-fluid',

  ui: {
    breadCrumbContainer: '.breadcrumb-container',
    submitButton: '.btn-submit',
    contactFormContainer: '.contact-form-container'
  },

  regions: {
    breadCrumbContainer: '@ui.breadCrumbContainer',
    contactSelect: '@ui.contactSelect',
    contactFormContainer: '@ui.contactFormContainer'
  },

  events: {
    'click @ui.submitButton': 'onClickSubmit'
  },

  onBeforeShow: function() {
    var contact = this.model.get('contact');
    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#coc/dashboard'
          },
          {
            text: contact.firstName + ' ' + contact.lastName,
            link: '#coc/contact/' + contact.contactId + '/dashboard'
          },
          {
            text: 'Edit Contact'
          }
        ]
      })
    );
    this.contactForm = new COCContactFormView({ model: this.model });
    this.showChildView('contactFormContainer', this.contactForm);
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(
      function() {
        var laddaContext = Ladda.create(this.ui.submitButton.get(0));
        laddaContext.start();
        SubmitContact(self.getFormData())
          .done(function(contact) {
            laddaContext.stop();
            Radio.channel('navigate').trigger('show:int:coc:contact', contact.contactId);
          })
          .fail(function() {
            laddaContext.stop();
          });
      }.bind(this)
    );
  },

  validate: function() {
    return this.ui.contactFormContainer.parsley().whenValidate();
  },

  getFormData: function() {
    var formData = this.contactForm.getFormData();
    formData.contactId = modelGet(this.model, 'contact.contactId');

    return formData;
  }
});
